<template>
  <div>
    <embedded-spinner :show="invoiceStatusInProgress" />
    <div v-if="invoiceStatus">
      <full-view-spinner :show="inProgress" />
      <br>
      <checkbox
        id="invoiceCheckbox"
        ref="invoiceCheckbox"
        name="invoiceCheckbox"
        :initial-value="invoiceStatus.invoiceStatus"
        :on-click="updateInvoiceStatus"
      >
        <p>{{ this.$i18n.t('INVOICE_CHECKBOX.DESCRIPTION') }}</p>
      </checkbox>
    </div>
  </div>
</template>

<script>

const RESP_VALIDATION_ERROR = 1;
const RESP_IN_PROGRESS = 2;
const RESP_OTHER_ERROR = 9999;

export default {
  name: 'InvoiceCheckbox',
  components: {},
  data: function() {
    return {
      inProgress: false,
    }
  },
  computed: {
    invoiceStatus: function() {
      return this.$store.getters['invoice/invoiceStatus'];
    },
    invoiceStatusInProgress: function() {
      return this.$store.getters['invoice/inProgress'];
    },
  },
  mounted: function() {
    this.$store.dispatch("invoice/refreshInvoiceStatus", this.$http);
  },
  methods: {
      updateInvoiceStatus: function() {
        if (!this.inProgress) {
          this.inProgress = true;
          const invoiceChangeRequest = {
            invoiceEnabled: this.$refs.invoiceCheckbox.getValue(),
          };
          this.$http.post('/api/user/invoice', invoiceChangeRequest)
            .then( (response) => {
              this.$store.commit("setSuccessMessage", this.$i18n.t('INVOICE_CHECKBOX.SUCCESS'));
              let newValue;

              if(!this.$refs.invoiceCheckbox.getValue()) {
                newValue = 'invoices enabled';
              } else {
                newValue = 'invoices disabled';
              }

              this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Success - '+newValue, value: 0, noninteraction: false });
            })
            .catch(callData => {
              this.processErrorCallResponse(callData);
            })
            .finally(() => {
              this.inProgress = false;
            })
        }
      },
      processErrorCallResponse: function(callData) {
        this.$refs.invoiceCheckbox.setValue(!this.$refs.invoiceCheckbox.getValue());

        if(callData.response === undefined || callData.response.data === undefined) {
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Error - no data', value: 0, noninteraction: false });
          return;
        }

        let responseCode = callData.response.data.responseCode;

        switch(responseCode) {
          case RESP_VALIDATION_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Error - validation', value: 0, noninteraction: false });
            break;
          case RESP_IN_PROGRESS:
            this.$store.commit("setWarningMessage", this.$i18n.t('INVOICE_CHECKBOX.IN_PROGRESS'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Error - in progress', value: 0, noninteraction: false });
            break;
          case RESP_OTHER_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Error - technical issue', value: 0, noninteraction: false });
            break;
          default:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Invoice checkbox',label: 'Error - '+responseCode, value: 0, noninteraction: false });
          }
      },
  }
}
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
